/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Nav_LabelInputs */

const en_booking_nav_label = /** @type {(inputs: Booking_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookings`)
};

const pl_booking_nav_label = /** @type {(inputs: Booking_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje`)
};

/**
* | output |
* | --- |
* | "Bookings" |
*
* @param {Booking_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_nav_label = /** @type {((inputs?: Booking_Nav_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Nav_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_nav_label(inputs)
	return en_booking_nav_label(inputs)
});